import {
  AvatarStack,
  Box,
  Card,
  Grid,
  GridSpan,
  Icon,
  Tag,
  Text,
} from '@factorialco/deprecated-design-system'
import { FeedbackEntryFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

const MAX_AVATARS = 4

export const FeedbackEntries: React.FC<{ entries: FeedbackEntryFragment[]; size?: GridSpan }> = ({
  entries,
  size,
}) => {
  const VISIBILITY = {
    private: i18n.t('performance_feedbacks.feedback_entry.private'),
    manager_only: i18n.t('performance_feedbacks.feedback_entry.manager_only'),
    private_and_manager: i18n.t('performance_feedbacks.feedback_entry.private_and_manager'),
  }

  const receiversAvatars = (feedbackEntry: FeedbackEntryFragment) => {
    return feedbackEntry.receivers.map((receiver) => ({
      label: receiver.fullName,
      url: buildUrl(receiver.avatarFull),
    }))
  }

  const parsedDate = (entry: FeedbackEntryFragment) => new Date(entry.createdAt)

  return (
    <Grid variant="fixed">
      <Box gridColSpan={{ xxs: 12, xs: size || 6 }}>
        {entries?.map((entry, index) => {
          const avatars = receiversAvatars(entry)
          return (
            <Box key={index} gap="s32" padding="s24" data-testid="feedback-entry">
              <Card>
                <Card.Content>
                  <Box gap="s8" width="full">
                    <Box
                      flexDirection="row"
                      gap="s8"
                      alignItems="center"
                      justifyContent="spaceBetween"
                    >
                      <Box flexDirection="row" gap="s8" alignItems="center">
                        <AvatarStack
                          size="s32"
                          textColor="viridian1000"
                          textSize="100"
                          backgroundColor="viridian200"
                          avatars={[
                            {
                              label: entry.author.fullName,
                              url: buildUrl(entry.author.avatarFull),
                            },
                          ]}
                          gap="s8"
                          leftover={0}
                        />
                        <Icon.Small icon="chevron-right" />
                        <AvatarStack
                          size="s32"
                          textColor="viridian1000"
                          textSize="100"
                          backgroundColor="viridian200"
                          avatars={avatars.slice(0, MAX_AVATARS)}
                          gap="s8"
                          leftover={avatars.length - MAX_AVATARS}
                        />
                      </Box>
                      <Box>
                        <Tag icon="eye-visible" leftItem="icon">
                          {VISIBILITY[entry.visibility]}
                        </Tag>
                      </Box>
                    </Box>

                    <Box gap="s16">
                      <Text.Normal>{entry.feedback}</Text.Normal>
                      <Text size="100" weight="semibold">
                        {parsedDate(entry).toDateString()}
                      </Text>
                    </Box>
                  </Box>
                </Card.Content>
              </Card>
            </Box>
          )
        })}
      </Box>
    </Grid>
  )
}
